const options = {
  5: "bg-pink-900/5",
  10: "bg-pink-900/10",
  25: "bg-pink-900/25",
  50: "bg-pink-900/50",
  75: "bg-pink-900/75",
  90: "bg-pink-900/90",
  100: "bg-pink-900",
};

const from = {
  5: "from-pink-900/5",
  10: "from-pink-900/10",
  25: "from-pink-900/25",
  50: "from-pink-900/50",
  75: "from-pink-900/75",
  90: "from-pink-900/90",
  100: "from-pink-900",
};

export default function getBackgroundPink900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
